<template>
  <dl class="article__dates">
    <slot />
  </dl>
</template>

<style lang="scss">
  .article__dates {
    overflow: hidden;

    > * {
      float: left;
    }

    > dt {
      clear: both;
      margin-right: $spacer05;
      font-weight: bold;
    }
  }
</style>
